import React from 'react';
import withAuthentication from '../../../../core/login/withAuthentication';
import { SectionNumber } from '../../constants';
import { VERIFICATION_AND_REVIEW_PAGES } from './constants';
import { GenericSection } from '../Sections/GenericSection';

const PaperworkVerificationAndReview = () => {
  return (
    <GenericSection
      pageCollection={VERIFICATION_AND_REVIEW_PAGES}
      section={SectionNumber}
      sectionValue={SectionNumber.VerificationAndReview}
    />
  );
};

export default withAuthentication(PaperworkVerificationAndReview);
